import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { RootState, useAppDispatch } from "../../state/store";
import { AuthState, initiateCheckAuth } from "../../state/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import "./varniLogin.css";
import { Varni_Select_Donation_Amount_Path } from "../../applicationRoutes";

const encKey = "vBqqnV9iZqRwRPdzmeC?kPCiqEJCUT";

export function VarniLogin() {

    const [username, setUsername] = useState<string | null>(null);
    const [password, setPassword] = useState<string | null>(null);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const authState = useSelector<RootState, AuthState>(rs => rs.AuthInfo);

    useEffect(() => {
        document.getElementsByTagName("body")[0].classList.remove("dontationbox-body");
        document.getElementsByTagName("body")[0].classList.remove("dontationbox");
        document.getElementsByTagName("body")[0].classList.add("varni-dontationbox-body");
        document.getElementsByTagName("body")[0].classList.add("varni-dontationbox");
    }, []);

    useEffect(() => {
        const storedUsername = localStorage.getItem("username");
        const storedPassword = localStorage.getItem("password");

        if (!storedUsername || !storedPassword)
            return;

        const decryptedUsernameObj = CryptoJS.AES.decrypt(storedUsername!, encKey);
        const decryptedUsername = decryptedUsernameObj.toString(CryptoJS.enc.Utf8);

        const decryptedPasswordObj = CryptoJS.AES.decrypt(storedPassword!, encKey);
        const decryptedPassword = decryptedPasswordObj.toString(CryptoJS.enc.Utf8);

        if (decryptedUsername && decryptedPassword) {
            setUsername(decryptedUsername);
            setPassword(decryptedPassword);
            dispatch(initiateCheckAuth({ username: decryptedUsername, password: decryptedPassword }));
        }
    }, []);

    const onUsernameChanged = (evt: any) => {
        setUsername(evt.target.value);
    }

    const onPasswordChanged = (evt: any) => {
        setPassword(evt.target.value);
    }

    const onLoginClicked = (evt: any) => {
        if (!username || !password) return;
        dispatch(initiateCheckAuth({ username, password }));
    }

    const renderLoginButton = () => {
        if (!username || !password)
            return (<Button variant="primary" size="lg" disabled>Login</Button>);

        if (authState.checkInProgress)
            return (<Button variant="primary" size="lg" disabled>Validating</Button>);

        return (<Button variant="primary" size="lg" onClick={onLoginClicked}>Login</Button>);
    }

    const renderLoginError = () => {
        if (authState.checkPass === false) {
            return (<Alert variant="error">Error in login - {authState.error}</Alert>);
        }

        return (<></>);
    }

    if (authState.checkPass) {
        const encUsername = CryptoJS.AES.encrypt(username!, encKey);
        const encPassword = CryptoJS.AES.encrypt(password!, encKey);
        localStorage.setItem("username", encUsername.toString());
        localStorage.setItem("password", encPassword.toString());
        return (<Navigate to={Varni_Select_Donation_Amount_Path} replace={true} />)
    }

    return (
        <Container className="mt-5">
            <Row>
                <Col md={3} sm={1} lg={3}></Col>
                <Col md={6} sm={1} lg={6}>
                    <Card>
                        <Card.Header>
                            Login
                        </Card.Header>
                        <Card.Body>
                            <Form>
                                <Form.Group className="mb-3" controlId="formUsername">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control size="lg" type="text" placeholder="Enter username" onChange={evt => onUsernameChanged(evt)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control size="lg" type="password" placeholder="Password" onChange={evt => onPasswordChanged(evt)} />
                                </Form.Group>
                            </Form>
                            {renderLoginButton()}
                            {renderLoginError()}
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} sm={1} lg={3}></Col>
            </Row>
        </Container>
    )
}